// extracted by mini-css-extract-plugin
export default {"overlay":"Sz-z","bodyOpen":"Tz-z","content":"Uz-z","header":"Vz-z","close":"Wz-z","closeNoHeading":"Xz-z"};